import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UserService} from "./user-service";
import {SessionService} from "./session-service";
import {HTTPCONSTANTS} from "../http/http-constants";

export default interface MarketWatchListItem {
  registration: string;
  sold_price: string;
  sold_date: Date;
  seller: string;
  formattedRegistration: string;
}

@Injectable({ providedIn: 'root' })
export class MarketWatchService {

  constructor(private httpClient: HttpClient, private snackbar: MatSnackBar, private userService: UserService) {}

  public GetTopSoldThiYear(callback: (results: MarketWatchListItem[]) => void): void {
    this.httpClient
      .get<MarketWatchListItem[]>(
        `${HTTPCONSTANTS.plato_search_protocol}${HTTPCONSTANTS.plato_search_base}?process=controller-market-watch-yearly-top-sold`
      )
      .subscribe(
        (res: MarketWatchListItem[]) => {
          callback(res);
        },
        () => callback(null)
      );
  }
}
